module.exports = __webpack_public_path__ + "static/media/navbar_mixer.2b84bbba.svg";